export enum ObjectCommentsError {
	// view
	VIEW_NOT_PERMITTED = '403 Forbidden, current user not permitted to use Confluence.',
	// Create
	NO_CREATE_PERMS = 'Could not create content with type comment',
	CONTAINER_NOT_FOUND = 'Content with id %d for comment container is not found. Please provide correct container id.',
}
